export default __webpack_public_path__ + "static/media/sage.ad50516f.svg";